"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalLinkFactory = void 0;
class InternalLinkFactory {
    constructor(portalMap) {
        this.portalMap = portalMap;
    }
    create(link) {
        const portalBaseUrl = this.getPortalBaseUrl(link.getPortalType());
        const path = link['getUrl']();
        link['getUrl'] = () => portalBaseUrl + path;
        return link;
    }
    getPortalBaseUrl(portalType) {
        const url = this.portalMap.get(portalType);
        return url || '';
    }
}
exports.InternalLinkFactory = InternalLinkFactory;
//# sourceMappingURL=InternalLinkFactory.js.map